import React, { useState } from 'react'

// Model
import TicketInfoModel from 'models/Ticket'

// Use
import useTable from 'use/table'

// Constants
import { API_TICKET_CLOSED_LIST } from 'constants/endpoints'

// Components
import Heading from 'ui/Heading'
import Datatable from 'ui/Datatable'
import ColumnAction from './Columns/ColumnAction'
import ColumnTicketMobile from './Columns/ColumnTicketMobile'
import { TicketsClosedFilters, defaultFilters } from './TicketsClosedFilters'

export const TicketsClosed = () => {
  const [filters, setFilters] = useState(defaultFilters)
  const { loading, data, total, page, onSortChange, onPageChange } = useTable({
    url: API_TICKET_CLOSED_LIST,
    method: 'POST',
    filters,
    model: TicketInfoModel,
    sortByDefault: 'ticketNumber',
    sortDirectionDefault: 'ascending',
  })

  const columns = [
    {
      title: 'Ticket no.',
      dataIndex: 'ticketNo',
      sortKey: 'ticketNumber',
      width: 140,
      renderMobile(text, row) {
        return <ColumnTicketMobile row={row} />
      },
    },
    {
      title: 'Date raised',
      dataIndex: 'raisedAt',
      sorter: true,
      sortKey: 'createDate',
    },
    {
      title: 'Category',
      dataIndex: 'category',
    },
    {
      title: 'Type',
      dataIndex: 'type',
    },
    {
      title: 'Date closed',
      dataIndex: 'closedAt',
      sorter: true,
      sortKey: 'statusChangedDate',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      noWrap: true,
      render(_, row) {
        return <ColumnAction row={row} />
      },
    },
  ]

  return (
    <>
      <Heading paddingTop={0}>Closed tickets</Heading>
      <Datatable
        responsive={true}
        loading={loading}
        page={page}
        columns={columns}
        data={data}
        total={total}
        perPage={10}
        onPageChange={onPageChange}
        onSortChange={onSortChange}
      >
        <TicketsClosedFilters
          filters={filters}
          onFiltersChange={(e) => setFilters(e)}
        />
      </Datatable>
    </>
  )
}

export default TicketsClosed
